import {InjectionToken} from '@angular/core'
import {CustomLiteralsEmbeddedService} from '@service/custom-literals/custom-literals.embedded.service'
import {CustomLiteralsService} from '@service/custom-literals/custom-literals.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

export function providerCustomLiteralsServiceFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new CustomLiteralsEmbeddedService() : new CustomLiteralsService()
}

export const CustomLiteralsServiceToken = new InjectionToken<CustomLiteralsService>('CustomLiteralsService')
